export const OwnerType = {
    USER: 'USER',
    BUSINESS: 'BUSINESS',
};
